import React, { Component } from 'react';
import { Alert, Box, Typography } from "@mui/material";
import { useState } from "react";
import Dialog from '../../../common/Dialog';
import { QrReader } from 'react-qr-reader';
import { isEmpty } from 'lodash';

const ScanQrCode = (props) => {
	const [data, setData] = useState({});
	const [err, setError] = useState("");

	const handleScan = (data) => {
		const { equipement_type, VEHICULES, EQUIPEMENTS } = props;
		let id = data.split("/").pop()
		console.log('====================================');
		console.log(id, data.split("/"));
		console.log('====================================');
		let equip = {}
		if (id ) {
			if (equipement_type === "vehicule") {
				equip = VEHICULES[id]
			}
			if (equipement_type === "equipement") {
				equip = EQUIPEMENTS[id]
			}
		}
		console.log('====================================');
		console.log({equip});
		console.log('====================================');
		if ( equip ) {
			setData(equip)
		} else {
			setError("Equipement Introuvable")
		}
	};
	const handleEquipement = () => {
		let option = {
			label: `${data.equipement_ref.toUpperCase()} | ${data.equipement_name}`,
			value: data.equipement_id,
			permanent: data.permanent_loan,
		}
		props.setEquipement(option)
		props.handleClose()
	};

	return (
		<Dialog
			close={props.handleClose}
			title={props.title}
			submitAction={(data && data.equipement_available) && handleEquipement}
		>
			<Box >
				
				{(!isEmpty(data) || err )? 
					<Box>
						{err ?
							<Alert severity="error">{err}</Alert>
						:
							<Box>
								<Box>
									<Typography variant="h6">{data.equipement_name}</Typography>
								{/* </Box>
								<Box> */}
									<Typography variant="button" color="primary" style={{ fontWeight: "bold"}} >Référence {data.equipement_ref}</Typography>
								</Box>
								<Box p={1} />
								<Box>
									<Typography variant="subtitle">Disponible : {data.equipement_available ? "Oui" : "Non"}</Typography>
								</Box>

								{!data.equipement_available &&
									<Box p={1}>
										<Alert severity="warning">Cet équipement n'est pas disponible, Impossible de l'attribuer</Alert>
									</Box>
								}
							</Box>
						}
					</Box>
				:
					<QrReader
						onResult={
							(result, error) => {
								if (!!result) {
									handleScan(result?.text)
								}

								if (!!error) {
									console.info(error);
								}
							}
						}
						style={{ width: '100%' }}
					/>
					
				}
			</Box>
		</Dialog>
	);
};

export default ScanQrCode;
